module.exports = __webpack_public_path__ + "static/media/karlovo.69cd0214.png";